import { ProgressBar } from '@ui/themed';
import { t } from 'i18next';
import type { ReactNode } from 'react';
import type { ChecklistProgress } from '../types';

type ChecklistProgressHeaderProps = {
  config: ChecklistProgress;
  completed: number;
  total: number;
  actions?: ReactNode;
};

export function ChecklistProgressHeader({
  config,
  completed,
  total,
  actions,
}: ChecklistProgressHeaderProps) {
  const isComplete = total > 0 && completed === total;
  const title =
    typeof config.title === 'function'
      ? config.title({ completed, total, isComplete })
      : config.title;
  const label = t('aria:checklist_progress', { completed, total });

  const bar = (
    <ProgressBar segments={total} filled={completed} caption title={title} label={label} />
  );

  if (!actions) {
    return bar;
  }

  // Actions stack above the bar once the header is too narrow to seat them alongside. No JS, breakpoint = width.
  return (
    <div className="@container w-full">
      <div className="flex @[22rem]:flex-row flex-col @[22rem]:items-center @[22rem]:gap-4 gap-1.5">
        <div className="@[22rem]:order-last flex flex-wrap justify-end gap-2">{actions}</div>
        <div className="min-w-0 flex-1">{bar}</div>
      </div>
    </div>
  );
}

// Mirrors ChecklistProgressHeader's layout so the real header drops in without a shift.
export function ChecklistProgressHeaderSkeleton({ total }: { total: number }) {
  return <ProgressBar.Skeleton title caption segments={total} />;
}
